import { Button, Checkbox, MaskedInput } from '@cian/ui-kit';
import * as style from './FindToday.css';
import clsx from 'clsx';
import { TModalForm } from 'shared/types/form';
import { PRIVACY_LINK, PROCESSING_LINK } from 'shared/constants/privacyPolicyLink';

type TFindTodayProps = TModalForm;

export const FindToday: React.FC<TFindTodayProps> = ({
  phoneRef,
  checkBoxRef,
  device,
  disabledButton,
  onSendForm,
  onFilledInput,
  user,
}) => {
  const { phone } = user;

  return (
    <form
      onSubmit={e => e.preventDefault}
      className={clsx(
        style['container'],
        device !== 'desktop' && style['container-tablet'],
        device === 'phone' && style['container-phone'],
      )}
    >
      <div className={style['text-container']}>
        <div className={style['textblock']}>
          <div className={style['title']}>Давайте найдём жильца уже сегодня</div>
          <div className={style['subtitle']}>Мы перезвоним и&nbsp;ответим на все вопросы</div>
        </div>
        <div className={style['image']} />
      </div>
      <div className={style['form-container']}>
        <div className={style['form']}>
          <div className={style['input-wrapper']}>
            <MaskedInput
              onChange={() => onFilledInput()}
              width="100%"
              size="M"
              defaultValue={phone}
              inputRef={phoneRef}
              mask="+7 000 000 00-00"
              placeholder="Номер телефона"
              lazy
            />
          </div>
          <div className={style['input-wrapper']}>
            <Button onClick={onSendForm} disabled={disabledButton} fullWidth size="M" theme="fill_white_primary">
              Сдать квартиру
            </Button>
          </div>
        </div>
        <div className={style['notice']}>
          <Checkbox inputRef={checkBoxRef} onChange={() => onFilledInput()} />
          <div className={style['notice-text']}>
            Нажимая кнопку, вы даете согласие на обработку <a href={PROCESSING_LINK}>персональных данных</a> в
            соответствии с <a href={PRIVACY_LINK}>Политикой конфиденциальности</a>.
          </div>
        </div>
      </div>
    </form>
  );
};
